import ability from '@/libs/acl/ability'
import { MUTATE_TOKEN, MUTATE_TOKEN_LOGOUT } from '@/modules/account/store/types'
import { CUSTOMER_CHAT_RESOURCE, READ_ACTION } from '@/constants/resources'
import { INIT, RESET } from './types'
import { CHAT_STATUS_IDLE } from './state'

// Liga o ciclo de vida do chat ao da sessão do Oráculo:
// - MUTATE_TOKEN (login, boot com sessão salva, /users/profile) → abilities já
//   aplicadas na CASL; com `customer_chat:read` inicia o chat (inbox + WS → badge do menu);
//   sem ela (permissão removida) derruba o que estiver aberto.
// - MUTATE_TOKEN_LOGOUT → fecha o WS e descarta o token de staff (só em memória).
export default store => {
  store.subscribe(mutation => {
    if (mutation.type === MUTATE_TOKEN_LOGOUT) {
      store.dispatch(RESET)
      return
    }
    if (mutation.type !== MUTATE_TOKEN) return
    if (ability.can(READ_ACTION, CUSTOMER_CHAT_RESOURCE)) {
      store.dispatch(INIT)
    } else if (store.state.customer_chat && store.state.customer_chat.status !== CHAT_STATUS_IDLE) {
      store.dispatch(RESET)
    }
  })
}
